import React, { useState, useContext, useEffect } from 'react';
import { MyContext } from '../../context/MyProvider';
import Dropdown from 'react-bootstrap/Dropdown';
import MyProfile from '../MyProfile';
import UserChangePassword from '../UserChangePassword';
import { requestHandler } from '../../helper';
import { getMyDetails } from '../../controller';



function Header() {
    const baseUrl = process.env.REACT_APP_BACKEND_URL
    const { toggleDropdownMain } = useContext(MyContext);


    const [user, setUser] = useState({});

    useEffect(() => {
        if (!user) {
            getAccountDetails()
        }
        // eslint-disable-next-line
    }, [])


    const getAccountDetails = async () => {
        await requestHandler(
            async () => await getMyDetails(),
            null,
            (res) => {
                setUser(res.data.user);
            },
            () => { }
        );
    };

    useEffect(() => {
        getAccountDetails();
    }, []);
    return (
        <>
            <header>
                <div>
                    <button onClick={toggleDropdownMain} className='bg-transparent p-0 border-0 toggel_icons d-none'>
                        <img className='toggel-icon' src="../images/png/toggel.png" width={17.33} height={13} alt="" />
                    </button>
                </div>

                <div>
                    {/* <img src="../images/png/user-img.png" width={41} height={41} alt="" />
                    <div className='dropdown-content open position-relative'>
                        <h6>Casey Roudine</h6>
                        <p>casey27@gmail.com</p>
                    </div> */}

                    <Dropdown className='user-dropdown-main'>
                        <Dropdown.Toggle className='user-dropdown text-start bg-transparent border-0'>
                            <div className='profile_image'>
                                <img className='w-100 h-100' src={user.profileImage ? baseUrl + '/' + user?.profileImage : "../images/png/user-img.png"} alt="" />
                            </div>
                            <div className='dropdown-content open position-relative'>
                                <h6>{user?.userName}</h6>
                                <p>{user?.email}</p>
                            </div>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <div className='dropdown-item'>
                                <MyProfile user={user} getAccountDetails={getAccountDetails} />
                            </div>
                            <div className='dropdown-item'>
                                <UserChangePassword />
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </header>
        </>
    )
}

export default Header